import { withErrorHandling } from "@/utils/withErrorHandling";
import { withLoading } from "@/utils/withLoading";

/**
 * Helper to handle loading and errors in a single function.
 * @param callback Function containing the logic of the backend request.
 * @param context Optional string to provide additional context for error handling.
 * @returns Result of the operation, handled with loading and errors.
 */
export const requestHandler = async <T>(
  callback: () => Promise<T>,
  context?: string
): Promise<T> => {
  return withLoading(() => withErrorHandling(callback, context));
};
